/**
 * Multi-Column Layout Module
 * Insert 2/3/asymmetric column sections into the blog editor.
 */

let editorEl = null;
let pageRef = null;

const LAYOUTS = [
    { id: '2col', label: '2 Columns', class: 'wp-columns-2', cols: 2 },
    { id: '3col', label: '3 Columns', class: 'wp-columns-3', cols: 3 },
    { id: '1-2', label: '1/3 + 2/3', class: 'wp-columns-1-2', cols: 2 },
    { id: '2-1', label: '2/3 + 1/3', class: 'wp-columns-2-1', cols: 2 },
];

export function showColumnPicker(editorElement, callback) {
    const existing = document.querySelector('.column-picker');
    if (existing) { existing.remove(); return; }

    const picker = document.createElement('div');
    picker.className = 'column-picker';
    picker.contentEditable = 'false';

    LAYOUTS.forEach(layout => {
        const btn = document.createElement('button');
        btn.className = 'column-picker-btn';
        btn.dataset.layout = layout.id;
        btn.innerHTML = `<span class="column-picker-preview column-picker-preview--${layout.id}"></span><span>${layout.label}</span>`;
        picker.appendChild(btn);
    });

    picker.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-layout]');
        if (!btn) return;
        e.preventDefault();
        const layout = LAYOUTS.find(l => l.id === btn.dataset.layout);
        if (layout) {
            picker.remove();
            callback(layout);
        }
    });

    // Position near the columns button
    const colBtn = editorElement.closest('.blog-card')?.querySelector('[data-cmd="insertColumns"]');
    if (colBtn) {
        const rect = colBtn.getBoundingClientRect();
        picker.style.position = 'fixed';
        picker.style.left = rect.left + 'px';
        picker.style.top = (rect.bottom + 4) + 'px';
    }
    document.body.appendChild(picker);

    setTimeout(() => {
        document.addEventListener('click', function close(ev) {
            if (!picker.contains(ev.target)) {
                picker.remove();
                document.removeEventListener('click', close);
            }
        });
    }, 0);
}

export function insertColumns(layout) {
    if (!editorEl) return;

    const section = document.createElement('section');
    section.className = `wp-columns ${layout.class}`;
    section.contentEditable = 'false';

    for (let i = 0; i < layout.cols; i++) {
        const col = document.createElement('div');
        col.className = 'wp-column';
        col.contentEditable = 'true';
        col.innerHTML = `<p>Column ${i + 1}</p>`;
        section.appendChild(col);
    }

    // Insert at caret or at end
    const sel = window.getSelection();
    if (sel.rangeCount) {
        const range = sel.getRangeAt(0);
        let block = range.startContainer;
        while (block && block !== editorEl && block.parentNode !== editorEl) {
            block = block.parentNode;
        }
        if (block && block !== editorEl) {
            block.after(section);
        } else {
            editorEl.appendChild(section);
        }
    } else {
        editorEl.appendChild(section);
    }

    // Add empty paragraph after for continued typing
    const p = document.createElement('p');
    p.innerHTML = '<br>';
    section.after(p);

    markDirty();
}

function markDirty() {
    if (pageRef) {
        pageRef.blogDirty = true;
        if (pageRef.activeBlogPost) {
            pageRef.activeBlogPost.content_html = editorEl.innerHTML;
        }
        if (pageRef.renderBlogDirtyUI) pageRef.renderBlogDirtyUI();
    }
}

// Backspace protection: prevent deleting column structure
function onKeydown(e) {
    if (e.key !== 'Backspace' && e.key !== 'Delete') return;

    const sel = window.getSelection();
    if (!sel.rangeCount) return;
    let node = sel.anchorNode;

    // Check if we're at the start of a .wp-column
    while (node && !node.classList?.contains('wp-column')) {
        node = node.parentNode;
    }
    if (!node || !node.classList.contains('wp-column')) return;

    if (e.key === 'Backspace' && sel.anchorOffset === 0) {
        // At start of column — check if we're in the first text node
        const range = sel.getRangeAt(0);
        const firstChild = node.firstChild;
        if (range.startContainer === firstChild || range.startContainer === node ||
            (firstChild && range.startContainer === firstChild.firstChild && range.startOffset === 0)) {
            e.preventDefault(); // Don't delete the column structure
        }
    }
}

export function init(editor, page) {
    editorEl = editor;
    pageRef = page;
    editor.addEventListener('keydown', onKeydown);
}
